import Api from '@/service/Api'

class DataAnalyticsService {
    getFilterObjects = async () => {
        return await Api().get(`analytics-filter-objects`)
    }
    getFilter = async (params) => {
        return await Api().get(`analytics-filter`, {
            params: params,
        })
    }
    generateCsv = async (payload) => {
        return await Api().post('analytics-file', payload)
    }
    getCsvRows = async (params) => {
        return await Api().get(`analytics-file`, {
            params: params,
        })
    }
    getCsvFile = async (csvId) => {
        return await Api().get(`analytics-csv-download`, { params: { csvId }, responseType: 'blob' })
    }
}

export default new DataAnalyticsService()
